import { Component, OnInit, OnDestroy, AfterViewInit, Directive, Input, AfterViewChecked } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { fadeInSlideAnimation } from 'animations';
import { RemoteServicesProvider } from 'providers/remote-services/remote-services';
import { DomainStorageProvider } from 'providers/domain-storage/domain-storage';
import { GetServiceUrl } from 'psapp-config';
import { SpotData } from 'dto';

@Directive({ selector: '[priceInput]' })
export class PriceInput implements AfterViewInit {

    @Input("inputId") id;

    ngAfterViewInit() {
        let input = document.querySelector<HTMLInputElement>("#" + this.id);
        if (input) {
            input.focus();
        }
    }
}

@Component({
    selector: 'app-newspot-products',
    templateUrl: './newspot-products.component.html',
    styleUrls: ['./newspot-products.component.scss'],

    animations: [fadeInSlideAnimation],
    host: { '[@fadeInSlideAnimation]': '' }
})
export class NewspotProductsComponent implements OnInit, OnDestroy {

    imageService = GetServiceUrl("ImageProduct");
    inputData = null;
    domainData = null;
    spotData: SpotData = null;

    constructor(
        private appService: AppService,
        private router: Router,
        public remoteService: RemoteServicesProvider,
        private domainStorageProvider: DomainStorageProvider,
    ) {
        this.showHideMenu(false);
    }

    ngOnInit() {
        this.spotData = this.domainStorageProvider.rootStore.spotData.value;
        if (!this.spotData) {
            this.router.navigate(["/searchpos"]);
        }

        this.domainData = this.domainStorageProvider.rootStore.products;
        this.inputData = {};
        this.domainData.forEach(product => {

            let hasSavedProduct = this.spotData && this.spotData.products && this.spotData.products[product.id] != null;

            this.inputData[product.id] = {
                checked: hasSavedProduct ? this.spotData.products[product.id].checked : false,
                showPrice: hasSavedProduct ? this.spotData.products[product.id].value : false,
                value: hasSavedProduct ? this.spotData.products[product.id].value : null
            };
        });
    }

    submitProducts() {
        let spotData = this.domainStorageProvider.rootStore.spotData.value;
        spotData.setProducts(this.inputData);
        this.router.navigate(["/newspot"]);
    }

    loadNotFoundImage(image) {
        image.src = "assets/imgs/rb_product_placeholder.jpg";
    }

    ngOnDestroy() {
        this.showHideMenu(true);
    }

    showHideMenu(show) {
        this.appService.onMainMenuEvent.emit(show);
    }

    back() {
        this.router.navigate(["/newspot"]);
    }
}
